import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deleteFailedTitle: {
		id: 'servicedesk.automation.edit-rule.ops.rule.delete.delete-failed-title',
		defaultMessage: 'Unable to delete rule',
		description: '',
	},
	deleteFailedDescription: {
		id: 'servicedesk.automation.edit-rule.ops.rule.delete.delete-failed-description',

		defaultMessage:
			'Please refresh the page to try again. If the problem persists, contact your administrator.',

		description: '',
	},
});
